import { useLocation } from 'react-router-dom';

import { Stack } from '@mui/material';

import { useFeatureFlags } from '@/entities/user/currentUser';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { inIframe } from '@/shared/lib/browser';
import { DesktopNavigation } from '@/shared/ui/DesktopNavigation';
import { Logo } from '@/shared/ui/Logo';
import { SidebarButton } from '@/shared/ui/SidebarButton';

import { getHelpNavOptions, getNavOptions } from '../../lib/getNavOptions';
import { BannerSidebar } from '../BannerSidebar';
import { ProfileItem } from '../ProfileItem';

type DesktopNavProps = {
  isOpen?: boolean;
  locked?: boolean;
  handleLocked?: () => void;
};

export const DesktopNav = ({ isOpen, locked, handleLocked }: DesktopNavProps) => {
  const { pathname } = useLocation();

  const { featureVisible: isVoicePresetsFeatureVisible } = useFeatureFlags('voice_presets');
  const { featureVisible: isGlossaryFeatureVisible } = useFeatureFlags('glossary');

  const mainNavigation = getNavOptions({
    isGlossaryFeatureVisible,
    isVoicePresetsFeatureVisible,
    pathname,
  });
  const bottomNavigation = getHelpNavOptions({ isWhiteLabel: IS_WHITE_LABEL });
  const opened = isOpen || locked;

  const isTiktok = inIframe();

  return (
    <DesktopNavigation
      logoContainer={
        <Logo
          isCompact={!opened}
          isWhiteLabel={IS_WHITE_LABEL}
          target={isTiktok ? undefined : '_blank'}
          to={isTiktok ? '/' : 'https://www.rask.ai/'}
        >
          <SidebarButton locked={locked} onClick={handleLocked} />
        </Logo>
      }
      bottomNavigation={bottomNavigation}
      mainNavigation={mainNavigation}
      profileContainer={<ProfileItem active={pathname === PATHS.account} />}
    >
      {opened && (
        <Stack margin="0 12px">
          <BannerSidebar />
        </Stack>
      )}
    </DesktopNavigation>
  );
};
